import { CategoryLink } from "../components/CategoryLink";
import { store } from "../portfolio";
import { getCategoryThumbnail } from "../imageCollections";
import "../css/paintings.css";

export default function Paintings() {
  return (
    <div className="category-list">
      {store.map((category) => {
        const key = category.title.toLowerCase();
        const imageSrc = getCategoryThumbnail(category.title, category.file);
        
  return (<CategoryLink key={key} target={"/" + key} file={imageSrc} title={category.title} />);
      })}
    </div>
  );
}
